export const inspection = {
  newTemplate: "New Template",
  editTemplate: "Edit Template",
  modelList: "Model List",
  InspectionTemplateDeletion: "Inspection Template Deletion",
  deleteInformation:
    'Replace a new inspection template for the vehicle models listed below, or select "None" to remove the inspection report function. You can apply an inspection report at a later time if desired.',
  selectAnInspectionTemplate: "Select an inspection template",
  // Format: type ["detail1", "detail2", ......]
  deleteUsedTip: `Confirm to delete the inspection template {0} and apply the changes? | Confirm to delete the inspection reports {0} and apply the changes?`,
  // Format: type ["detail1", "detail2", ......]
  deleteNotUsedTip:
    "The inspection template {0} will be deleted. Are you sure you want to proceed? | The inspection reports {0} will be deleted. Are you sure you want to proceed?",
  failedDeleteInspectionTemplateUsed:
    "Failed to delete. The inspection templates are used.",
  customItem: "Custom Item",
  customSection: "Custom Section",
  customGroup: "Custom Group",
  criticalItem: "Critical Item",
  pleaseInputItemName: "Please input an item name",
  pleaseInputSectionName: "Please input a section name",
  pleaseInputGroupName: "Please input a group name",
  pleaseInputTemplateName: "Please input a template name",
  inspectionItemUsedUpdateItAnyway:
    "This field is used by other templates. Update it anyway?",
  InspectionTemplateUsedUpdateItAnyway: "Confirm changes.",
  failedToSaveTemplateNameAlreadyExist:
    "Failed to save. The template Name already exists.",
  failedToSaveTemplateEmpty:
    "Failed to save. The template should include at least one inspection item.",
  tipsTemplateEmpty:
    "The template should include at least one inspection item.",
  // Format: type ["detail1", "detail2", ......]
  failedToSaveGroupNameAlreadyExist:
    'Failed to save. The group name "{0}" already exists.',
  // Format: type ["detail1", "detail2", ......]
  failedToSaveSectionNameAlreadyExist:
    'Failed to save. The section Name "{0}" already exists. ',
  // Format: type ["detail1", "detail2", ......]
  failedToSaveItemNameAlreadyExist:
    'Failed to save. The item "{0}" already exists',
  failedToDeleteGroupNotEmpty: "Failed to delete. The group is not empty.",
  failedToDeleteSectionNotEmpty: "Failed to delete. The section is not empty.",
  failedToDeleteItemUsed:
    "Failed to delete. The item is used by another template.",
  // Format: type ["detail1", "detail2", ......]
  deleteInspectionItemTip:
    'The inspection item "{0}" will be deleted. Are you sure you want to proceed?',
  // Format: type ["detail1", "detail2", ......]
  deleteInspectionGroupTip:
    'The inspection group "{0}" will be deleted. Are you sure you want to proceed?',
  // Format: type ["detail1", "detail2", ......]
  deleteInspectionSectionTip:
    'The inspection section "{0}" will be deleted. Are you sure you want to proceed?',
};
